import styled from 'styled-components';
import React from 'react';
import { VerticalMenuIcon } from '@ontruck/fe-icons';

const Wrapper = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  cursor: pointer;
  background-color: var(--grey200);
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    background-color: var(--grey300);
  }
`;

export const MenuButton = (props) => {
  return (
    <Wrapper {...props}>
      <VerticalMenuIcon sizeInPixels={24} />
    </Wrapper>
  );
};

export default MenuButton;
